
@if (!clusterTable) {
  <div class="badgescontainer">
    @if (isReviewed) {
      <div class="label-tooltip badgeSvgFirst">
        <img style="vertical-align: unset; width: 20px;" alt="reviewed" [ngClass]="isSummary == true ? 'badgeTitleSvg' : 'badgeSvg'" src="assets/img/reviewed.svg" />
        <span class="label-tooltip-text hide-for-small-only">
          Reviewed
        </span>
      </div>
    }
    @if (!isReviewed) {
      <div  class="label-tooltip badgeSvgFirst">
        <img style="vertical-align: unset; width: 20px;" alt="unreviewed" [ngClass]="isSummary == true ? 'badgeTitleSvg' : 'badgeSvg'" class="badgeSvg" src="assets/img/unreviewed.svg" />
        <span class="label-tooltip-text hide-for-small-only">
          Unreviewed
        </span>
      </div>
    }
    @if (isProteome) {
      <div class="label-tooltip badgeSvgFirst">
        <img style="vertical-align: unset; width: 20px;" alt="ref" [ngClass]="isSummary == true ? 'badgeTitleSvg' : 'badgeSvg'" class="badgeSvg" src="assets/img/reference-proteome.svg" />
        <span class="label-tooltip-text hide-for-small-only refPro">
          Reference proteome
        </span>
      </div>
    }
  </div>
}


@if (clusterTable) {
  <span style="display:flex;">
    @if (isReviewed === 'true') {
      <span class="badgeSvgFirst">
        <div class="label-tooltip" style="display: inline;">
          <img alt="reviewed" [ngClass]="isSummary == true ? 'badgeTitleSvg' : 'badgeSvg'" src="assets/img/reviewed.svg" width="20" height="20" />
          <span class="label-tooltip-text hide-for-small-only refPro">
            Reviewed (Swiss-Prot)
          </span>
        </div>
      </span>
    }
    @if (isReviewed === 'false') {
      <span class="badgeSvgFirst">
        <div class="label-tooltip" style="display: inline;">
          <img alt="unreviewed" [ngClass]="isSummary == true ? 'badgeTitleSvg' : 'badgeSvg'" class="badgeSvg" src="assets/img/unreviewed.svg" width="20" height="20" />
          <span class="label-tooltip-text hide-for-small-only">
            Unreviewed
          </span>
        </div>
      </span>
    }
    @if (isProteome === 'true') {
      <span class="badgeSvgFirst">
        <div class="label-tooltip" style="display: inline;">
          <img alt="ref" [ngClass]="isSummary == true ? 'badgeTitleSvg' : 'badgeSvg'" class="badgeSvg" src="assets/img/reference-proteome.svg" width="20" height="20" />
          <span class="label-tooltip-text hide-for-small-only refPro">
            Reference proteome
          </span>
        </div>
      </span>
    }
  </span>
}